import {
  Button,
  TextInput,
  useFieldArray,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { useMemo, useRef } from "react";
import styles from "../../../CreateFormTemplate.module.scss";

const cx = classNames.bind(styles);

export const PickListFields = ({ fieldKey }: { fieldKey?: string }) => {
  const keyToUse = useMemo(() => {
    return fieldKey ?? "pick_list_values";
  }, [fieldKey]);
  const fieldsContainerRef = useRef<HTMLDivElement>(null);
  const { fields, append, remove } = useFieldArray({
    name: keyToUse,
  });

  return (
    <div>
      <Button
        className={cx("addPicklistItemButton")}
        onClick={() => {
          append("");

          // wait for one render cycle to ensure the new field is rendered
          setTimeout(() => {
            fieldsContainerRef.current?.lastElementChild?.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
          }, 0);
        }}
        icon="plus-circle"
      >
        Add Picklist Item
      </Button>

      {fields.map((field, index: number) => (
        <div
          key={field.id}
          className={cx("pickListOptionsContainer")}
          ref={fieldsContainerRef}
        >
          <div style={{ flex: 1 }}>
            <TextInput
              name={`${keyToUse}.${index}`}
              isRequired
              placeholder={`Option ${index + 1}`}
              isFluid
              isInline
            />
          </div>

          {fields?.length > 1 ? (
            <Button
              icon="minus-circle"
              onClick={() => remove(index)}
              variant="error-outline"
            />
          ) : null}
        </div>
      ))}
    </div>
  );
};
